var matchesProperty = {};
export {
  matchesProperty as __exports
};
//# sourceMappingURL=matchesProperty.js.map
